'use strict'

$(document).on('click', '.js-fitanalitycs-wrp', function (e) {
    if(typeof window.dataLayer != 'undefined'){
        var $anchor = $(e.target).closest('a', this);
        if (!$anchor.length) return;
      
        var $skuEl = $('#product-id-sku');
        if (!$skuEl.length) return;
      
        var productId = $skuEl.text();
        if (!productId) return;
      
        productId = productId.trim();
        if (!productId) return;
      
        window.dataLayer.push({
          event: 'generic_event',
          event_category: 'fit_finder',
          event_label: productId
        });
    }

  });
  